module.exports = __webpack_public_path__ + "img/btn_play@2x.2c2c2af2.png";